import React from "react";
import ButtonBox from "./UnitButtonBox";
import DataCanvas from "./DataCanvas";
import error from "./imagenotthere.png";

export default class DataCanvasContainer extends React.Component {
  state = {
    values: [],
    i: 0
  }

  componentDidMount() {
    this.preload();
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.product !== this.props.product
        || prevProps.cycle !== this.props.cycle
        || prevProps.date !== this.props.date) {
      this.preload();
    }
  }

  getUnitData = (property) => {
    return this.props.units[this.props.unit][property];
  }

  getValues = () => {
    const start = Number(this.getUnitData("start"));
    const by = Number(this.getUnitData("by"));
    const limit = Number(this.props.unitThreashold);

    const length = limit / by + 1 - start;
    const values = this.props.unit === "full" ? ["000"] : Array.from({ length }).map( (_,i) => {
       by === 1 ? i+=by : i*=by;
       return (
         (i) < 10 ? "00" + (i) : (i) > 99 ? (i) :  "0"+(i)
       )
    });
    return values;
  }

  preload() {
    const values = this.getValues();
    const images = Array.from({length: values.length})
    const preload = Promise.all(values.map(
      (val) => (this.props.getSource(val))).map(
        (url, i) => {
          return new Promise((fullfill, reject) => {
            let img = new Image();
            img.onload = fullfill;
            img.onerror = reject;
            img.src = url;
            images[i] = <img src={url}
                             alt="Forecast"
                             onError={(e) => { e.target.src = error; }}
                             />;
          });
        }
      ));
    this.setState({ values, preload, images });
  }

  change = (i) => {
    this.setState({ i });
  }

  render() {

      if(this.state.images) {
        return (
          <div className="data-canvas-container">

            <ButtonBox
              classname={"horizontal"}
              title={this.getUnitData("unitHeader")}
              buttonValues={this.getValues()}
              onEvent={this.props.onEvent}
              change={this.change}
            />
            <DataCanvas img={this.props.domainImg || this.state.images[this.state.i]} />
          </div>
        );
      } else {
        return( <div /> );
      }
    }
}



// WEBPACK FOOTER //
// ./src/DataCanvasContainer.js